const SvgHostname = (props) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" {...props}>
    <g fill="none" fillRule="nonzero">
      <path
        d="M9 12.805l7.062-5.274 1.1-.817L9 .624.836 6.714l1.093.818 7.07 5.273z"
        stroke="currentColor"
      />
      <path
        d="M9 15.927L1.62 10.43 0 10.573l9 6.715 9-6.715-1.63-.152z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default SvgHostname
